import { useI18n } from "vue-i18n";

interface TranslationHelper {
    changeCode(code: number): string;
}

export function returnCode(): TranslationHelper {
    const { t } = useI18n();

    return {
        changeCode: (code: number | null | undefined): string => {
            if (code === null || code === undefined) {
                return `현재 returnCode가 ${code}입니다.`;
            }
            const translation = t(`returnCode.${code.toString()}`);
            if (translation === `returnCode.${code.toString()}`) {
                console.warn(code);
                return `returnCode:${code}를 변환하지 못했습니다.`;
            }

            return translation as string;
        },
    };
}
